import { createContext } from "react";

export const SnackBarContext = createContext({
    showSnackBar: false,
    show: (message) => {},
  });